import React, { useRef, useEffect } from 'react';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';

import { useField } from '@unform/core';
import { ContainerError, ContentInput, ContentInputandLabel } from './styles';
//import { IconBaseProps } from 'react-icons/lib';

interface Props extends InputProps {
  name: string;
  textLabel: string;
  //icon?: React.ComponentType<IconBaseProps>;
}

const InputMask: React.FC<Props> = ({ name, textLabel, ...rest } : Props) => {
  const inputRef = useRef<ReactInputMask>(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue(ref, value: string) {
        ref.setInputValue(value);
      },
      clearValue(ref) {
        ref.setInputValue('');
      },
    });
  }, [fieldName, registerField]);

  return (
    <ContentInputandLabel>
    <label htmlFor={name}>{textLabel}</label>
    <ContentInput error={error ? true : false}>
    <ReactInputMask
      ref={inputRef}
      defaultValue={defaultValue}
      {...rest}
    />
    {error && (
        <ContainerError>
          <span>{error}</span>
        </ContainerError>
      )}
    </ContentInput>
    </ContentInputandLabel>
  );
};

export default InputMask;
